export default __webpack_public_path__ + "static/media/Vector.48ffb029.svg";